import { gql } from "@apollo/client"

export const SUBSCRIPTION_ON_ERROR_LIVE = gql`
  subscription SubscriptionOnErrorLive($liveId: ID!) {
    onErrorLive(liveId: $liveId) {
      liveId
      data
      message
      code
    }
  }
`;
export const SUBSCRIPTION_ON_SELECT_STOCK_TO_LIVE = gql`
  subscription OnSelectStockToLive($liveId: ID!, $shopId: ID!) {
    onSelectStockToLive(liveId: $liveId, shopId: $shopId) {
      _id
      amount
      amountAll
      live {
        _id
        pageName
        description
      }
      stock {
        _id
        price
        currency
        amount
        image
        name
        unit
        cfMessage
        isDeleted
        optionValues {
          _id
          name
          value
        }
      }
      shop {
        _id
        name
        phone
        point
        image
        paymentType
      }
      cfMessage
      isPublished
    }
  }
`;